import React, { FC } from 'react';
import { FiltersProvider } from '../search-snippets/aside/filter-selected/FiltersProvider';
import { FilterType } from '../search-snippets/aside/filter-selected/FilterItem';
import styles from './mobile_filters.module.scss';
import { ResultsType } from '../../state/reducers/results.types';
import { SearchExceptExpressions } from '../except-expressions/SearchExceptExpressions';
import { FiltersList } from '../search-snippets/aside/filter-selected/FiltersList';

type Props = {
  exceptExpressions: ResultsType['exceptExpressions'];
};

export const MobileFilters: FC<Props> = ({ exceptExpressions = [] }) => (
  <FiltersProvider>
    {(filters: Array<FilterType>) => {
      if (!filters.length && !exceptExpressions.length) {
        return null;
      }
      return (
        <div className={styles.container}>
          <SearchExceptExpressions exceptExpressions={exceptExpressions} />
          <FiltersList filters={filters} />
        </div>
      );
    }}
  </FiltersProvider>
);
